module.exports = __webpack_public_path__ + "img/logo.9ae404b5.png";